import { Passenger } from "../../../shared/types/schema";

const getContactPhone = (passengers: Array<Passenger>) => passengers.find((passenger) => passenger.phone)?.phone;

export default getContactPhone;
